export default "/images/category.svg?5322df7a2068f88065fae4c2c6363ca9";